import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from 'state/modules/app';
import { Link } from 'react-router-dom';
import AuthError from 'components/AuthError';
import btnStyles from 'styles/partials/_button.css';
import componentStyles from 'styles/partials/_login.css';
import AppContext from '../../components/Context/AppContext';

class RequestPasswordReset extends Component {
  constructor(props) {
    super(props);
    this.handleRequest = this.handleRequest.bind(this);
    this.state = { username: '' };
    this.styles = {};
    Object.assign(this.styles, componentStyles, btnStyles);

    this.usernameRef = React.createRef();
    this.submitRef = React.createRef();
  }

  componentDidMount() {
    const app = this.props.app;
    if (app.isLoggedIn) {
      this.context.history.pushState(null, `/`);
    }
  }

  componentWillReceiveProps(nextProps) {
    const app = nextProps.app;
    if (app.isLoggedIn) {
      this.context.history.pushState(null, `/`);
    }
  }

  handleUserChange(event) {
    this.setState({ username: event.target.value });
  }

  render() {
    const { app } = this.props;
    let appMessage = '';
    if (app.authAlert) {
      appMessage = app.authAlert.message;
    }
    return (
      <div className={this.styles['container']}>
        {app.authAlert ? (
          <AuthError
            screen="reset"
            icon={app.authAlert.type === 'success' ? '' : 'error'}
            message={appMessage || 'Password reset request failed'}
          />
        ) : (
          ''
        )}
        <div className={this.styles['loginDim']} />
        <div className={this.styles['loginSection']}>
          <div className={this.styles['loginBoxes']}>
            <div className={this.styles['loginTealBox']} />
            <div className={this.styles['loginIndigoBox']} />
          </div>
          <div className={this.styles['loginLogo']}>
            <img className={this.styles['loginLogoImg']} src="/images/OGL-Profit4Logo.png" alt="OGL Profit4 Logo" />
          </div>
          <div className={this.styles['loginForm']}>
            <form className={this.styles['formContainer']} onSubmit={this.handleRequest}>
              <h3 className={this.styles['heading']}>
                <span className={this.styles['headingAlt']}>Request Password Reset</span>
              </h3>
              <p className={this.styles['text']}>Please provide your username or email address.</p>
              <p className={this.styles['text']}>
                You will then receive an email that will allow you to reset your password.
              </p>
              <input
                type="text"
                ref={this.usernameRef}
                onChange={this.handleUserChange.bind(this)}
                value={this.state.username}
                className={this.styles['input']}
                aria-describedby="sizing-addon1"
                placeholder="Username"
              />
              <button ref={this.submitRef} type="submit" className={this.styles['loginBtn']}>
                <i
                  style={{
                    paddingRight: 5 + 'px',
                    lineHeight: 'inherit',
                    verticalAlign: 'bottom',
                  }}
                  className="iconSmall"
                  aria-hidden="true"
                >
                  email
                </i>
                Send verification email
              </button>
              <Link to="/Login" className={this.styles['forgotten']}>
                Return to Login Screen
              </Link>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleRequest(e) {
    e.preventDefault();
    const username = this.state.username;
    this.submitRef.current.blur();
    this.props.dispatch(appActions.requestPasswordReset(username));
    this.state = { username: '' };
    this.context.history.pushState(null, `/Login`);
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

RequestPasswordReset.contextType = AppContext;

export default connect(mapStateToProps)(RequestPasswordReset);
